import React, { useState } from "react";
import DashboardHeader from "../components/DashboardHeader";
import CererePuncte from "./puncte/CererePuncte"; 
import PointsHistory from "./puncte/PointsHistory"; 
import TopMembri from "./puncte/TopMembri"; 

function PunctePage({ memberData }) {
  const [activeTab, setActiveTab] = useState("istoric");

  return (
    <div className="dashboard-wrapper" style={{ overflowX: "hidden", minHeight: "100vh", backgroundColor: "#0b1120", paddingBottom: "40px" }}>
      <DashboardHeader user={memberData} />
      
      {/* Stiluri injectate pentru taburile dark premium */}
      <style>{`
        .premium-tabs-container {
          display: flex;
          gap: 12px;
          background: rgba(255, 255, 255, 0.02);
          padding: 8px;
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          margin-top: 36px;
          margin-bottom: 24px;
          overflow-x: auto;
        }
        .premium-tab-btn {
          background: transparent;
          color: #94a3b8;
          border: none;
          padding: 12px 24px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 0.95rem;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;
        }
        .premium-tab-btn:hover {
          color: #cbd5e1;
          background: rgba(255, 255, 255, 0.05);
        }
        .premium-tab-btn.active {
          background: #1e293b;
          color: #fbbf24;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.05);
        }
      `}</style>

      <div className="container" style={{ maxWidth: 1140, margin: "0 auto", padding: "0 16px" }}>
        
        <div className="premium-tabs-container">
          <button
            className={`premium-tab-btn ${activeTab === "istoric" ? "active" : ""}`}
            onClick={() => setActiveTab("istoric")}
            type="button"
          >
            Istoric puncte
          </button>
          <button
            className={`premium-tab-btn ${activeTab === "cerere" ? "active" : ""}`}
            onClick={() => setActiveTab("cerere")}
            type="button"
          >
            Cerere atribuire puncte
          </button>
          <button
            className={`premium-tab-btn ${activeTab === "top" ? "active" : ""}`}
            onClick={() => setActiveTab("top")}
            type="button"
          >
            Top Membri
          </button>
        </div>

        {/* Conținut taburi */}
        <div className="tab-content">
          {activeTab === "istoric" && <PointsHistory memberId={memberData?.id} />}
          {activeTab === "cerere" && <CererePuncte memberId={memberData?.id} />}
          {activeTab === "top" && <TopMembri />}
        </div>
      </div>
    </div>
  );
}

export default PunctePage;
